import type { BridgeErrorCode } from "@/src/lib/bridge/types";

const APP_PURCHASE_ERROR_MESSAGES = {
  BILLING_USER_CANCELED: "Payment cancelled, you can try again anytime",
  BILLING_SERVICE_UNAVAILABLE: "Network hiccup — please try again in a moment",
  BILLING_UNAVAILABLE: "Payment isn't available on this device right now",
  BILLING_ITEM_UNAVAILABLE: "This plan isn't available at the moment",
  BILLING_DEVELOPER_ERROR: "Something went wrong — try restarting the app",
  BILLING_INTERNAL_ERROR:
    "Payment didn't go through, please give it another try",
  BILLING_UNKNOWN_PRODUCT_DETAILS_UNSUPPORTED:
    "Your device/OS doesn't support in-app purchases. Please upgrade your system or update Google Play and try again.",
  UNEXPECTED: "Something unexpected happened — please try again",
} as const;

/**
 * Bridge `error.code` -> 用户提示文案
 * 这里的 toast 文案来自产品侧约定：code/错误类型/展示文案一一映射。
 */
export function getBridgeErrorToastMessage(code?: BridgeErrorCode): string {
  switch (code) {
    // 1 USER_CANCELED
    case "BILLING_USER_CANCELED":
      return APP_PURCHASE_ERROR_MESSAGES.BILLING_USER_CANCELED;
    // 2 SERVICE_UNAVAILABLE
    case "BILLING_SERVICE_UNAVAILABLE":
      return APP_PURCHASE_ERROR_MESSAGES.BILLING_SERVICE_UNAVAILABLE;
    // 3 BILLING_UNAVAILABLE
    case "BILLING_UNAVAILABLE":
      return APP_PURCHASE_ERROR_MESSAGES.BILLING_UNAVAILABLE;
    // 4 ITEM_UNAVAILABLE
    case "BILLING_ITEM_UNAVAILABLE":
      return APP_PURCHASE_ERROR_MESSAGES.BILLING_ITEM_UNAVAILABLE;
    // 5 DEVELOPER_ERROR
    case "BILLING_DEVELOPER_ERROR":
      return APP_PURCHASE_ERROR_MESSAGES.BILLING_DEVELOPER_ERROR;
    // 6 ERROR
    case "BILLING_INTERNAL_ERROR":
      return APP_PURCHASE_ERROR_MESSAGES.BILLING_INTERNAL_ERROR;
    // Android BillingResponseCode.FEATURE_NOT_SUPPORTED(-2)
    // 新版原生会透传为 BILLING_UNKNOWN_-2
    case "BILLING_UNKNOWN_-2":
      return APP_PURCHASE_ERROR_MESSAGES.BILLING_UNKNOWN_PRODUCT_DETAILS_UNSUPPORTED;
    default:
      return APP_PURCHASE_ERROR_MESSAGES.UNEXPECTED;
  }
}
